import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'

export default createUIDefinition({
    taskName: taskName.SELECT_REFINEMENT_TYPE,
    taskOverviewProps: {},
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.REFINEMENT_REASON_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.SENT_EMAIL_WIDGET,
        },
        {
            component: processUI.INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.PAYMENT_LIST_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
        {
            component: processUI.TECHNICAL_LOG_CONTAINER,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/select-refinement-type.js